import PaidIcon from "@mui/icons-material/Paid";
import permissions from "app/permissions";
import { DoctoralServicePath } from "utils/constants";
import ListDoctoralSchoolFees from "./List";
import CreateDoctoralSchoolFee from "./Create";
import EditDoctoralSchoolFee from "./Edit";

export const resources = {
  isMenu: true,
  icon: <PaidIcon />,
  name: `${DoctoralServicePath}doctoral-school-fees`,
  title: "Такси за докторантско училище",
  list: <ListDoctoralSchoolFees />,
  create: <CreateDoctoralSchoolFee />,
  createPermission: permissions.canCreateDoctoralSchoolCampaigns,
  edit: <EditDoctoralSchoolFee />,
  editPermission: permissions.canUpdateDoctoralSchoolCampaigns,
  permission: permissions.canPreviewDoctoralSchoolCampaigns,
};
